import { Loader2 } from 'lucide-react';

export function RouteLoadingSkeleton(): React.ReactElement {
  return (
    <div className="min-h-[40vh] flex items-center justify-center">
      <div
        className="flex flex-col items-center gap-2 text-text-muted"
        role="status"
        aria-live="polite"
      >
        <Loader2 className="h-6 w-6 animate-spin" />
        <span className="text-sm">Loading...</span>
      </div>
    </div>
  );
}
